module.exports = __webpack_public_path__ + "img/loading.ac351699.gif";